import { createIcon } from '@chakra-ui/react';

export const ArrowRightIcon = createIcon({
  displayName: 'ArrowRightIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      d='M17.914 16.3532L18.2664 16L17.914 15.6468L12.1601 9.88038L13.3334 8.70711L20.6263 16L13.3334 23.2929L12.1601 22.1196L17.914 16.3532Z'
      fill='currentColor'
      stroke='currentColor'
    />
  ),
});
